<template>
	<div class="widget" :style="{ backgroundColor: widget.settings.bgColor }">
		<div
			class="widget-qr"
			:class="{ 'with-label': widget.settings.showLabel }"
			:style="{ borderColor: widget.settings.color, width: `${widget.settings.size}%` }"
		>
			<qr-code
				:text="widget.settings.content"
				:color="widget.settings.color"
				:bg-color="widget.settings.bgColor"
				:error-level="widget.settings.errorLevel"
				class="widget-qr-code"
				:style="{ borderColor: widget.settings.bgColor }"
			/>
			<div
				v-if="widget.settings.label"
				:style="labelStyle"
				class="widget-qr-text"
			>
				{{ widget.settings.label }}
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VueQRCodeComponent from 'vue-qrcode-component'

Vue.component('qr-code', VueQRCodeComponent)

export default {
    name: 'WidgetView',
	props: {
		widget: Object
	},
	computed: {
		labelStyle () {
			let border = this.widget.settings.bgColor
			let text = this.widget.settings.color
			if (this.widget.settings.showLabel) {
				border = this.widget.settings.color
				text = this.widget.settings.bgColor
			}
			return {
				backgroundColor: border,
				color: text
			}
		}
	}
}
</script>

<style lang="scss">

.widget {

	@include flex(flex, row, nowrap, center, center);
	height: 100%;
	width: 100%;

	&-qr {

		&.with-label {

			border-radius: 12px;
			border-style: solid;
			border-width: 10px;

			.widget-qr-code {
				border-style: solid;
				padding: 7%;
			}

		}

		&-code {

			canvas {
				aspect-ratio: 1 !important;
				width: 100%;
			}

			img {
				display: block;
				height: 100%;
				width: 100% !important;
			}

		}

		&-text {
			font-size: 20px;
			font-weight: 600;
			padding: 15px 0 5px;
			text-align: center;
			text-transform: uppercase;
			width: 100%;
		}

	}

}

</style>
